import { Component, Input } from '@angular/core';
import { ChargepointStatus } from '../../../api/chargepoints-api.service';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-chargepoint-status',
  templateUrl: './chargepoint-status.component.html',
  styleUrls: ['./chargepoint-status.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class ChargepointStatusComponent {

  @Input() status?: ChargepointStatus;

  constructor() { }
}
